export function jsonStringify(data: unknown): string {
  return JSON.stringify(data, (_, v) => (typeof v === 'bigint' ? v.toString() : v));
}
